import { Type } from '@v2/components/campaign/Info';
import PropTypes from 'prop-types';

export const sectionInfoType = PropTypes.shape({
  type: PropTypes.oneOf(Object.keys(Type)),
  name: PropTypes.string,
  content: PropTypes.node,
});
